<mat-sidenav-container class="navigator-container" autosize #drawerContainer>
  <!-- Menu de la izquierda -->
  <mat-sidenav
    #drawer
    class="navigator-sidenav sidenav-fixed"
    mode="side"
    opened="true"
    style="overflow-x: hidden"
    [attr.role]="(helper.isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(helper.isHandset$ | async) ? 'over' : 'side'"
    [opened]="(helper.isHandset$ | async) === false"
    [style.width.px]="drawerWidth"
    [style.minWidth.px]="drawerWidth"
    (openedChange)="avisarCambioDeAncho()"
  >
    <section
      style="
        display: flex;
        flex-direction: column;
        height: 100%;
        position: relative;
      "
    >
      <!-- Cerrar el menú: con el menú abierto el botón vive acá, junto a lo
           que controla; cerrado, vuelve a la barra superior -->
      <button
        irxBotonIcono
        tamano="compacto"
        class="shell-cerrar-menu"
        tooltip="Ocultar menú"
        (click)="drawer.toggle()"
      >
        <mat-icon>menu_open</mat-icon>
      </button>
      <!-- Usuario y cambio de permiso -->
      <app-usuario (permisoChanged)="onPermisoChanged()"></app-usuario>

      <!--  -->
      <div class="main2" style="overflow-y: auto">
        <mat-nav-list appAbrirNuevaPestania>
          <mat-divider class="navigator-divider"></mat-divider>
          @if (clientePropio?.tipoCliente === 'Mayorista') {
            <a
              mat-list-item
              routerLinkActive="active"
              [routerLink]="['dashboard-general']"
              [state]="estadoRaiz"
            >
              <span class="nav-link">
                <span class="nav-link">
                  <mat-icon matSuffix>dashboard</mat-icon>
                  <span class="text-menu">Dashboard</span>
                </span>
              </span>
            </a>
          }
          <!-- Mapa General -->
          @if (modulosHabilitados?.length > 1 || helper.esNivel0()) {
            <a
              mat-list-item
              routerLinkActive="active"
              [routerLink]="['mapa']"
              [state]="estadoRaiz"
            >
              <span class="nav-link">
                <mat-icon matSuffix>map</mat-icon>
                <span class="text-menu">Mapa</span>
              </span>
            </a>
          }

          <!-- Eventos Genéricos -->
          @if (helper.tienePermiso('Eventos - Ver eventos')) {
            <a
              mat-list-item
              routerLinkActive="active"
              [routerLink]="['eventos-genericos']"
              [state]="estadoRaiz"
            >
              <span class="nav-link">
                <mat-icon matSuffix>report</mat-icon>
                <span class="text-menu">Eventos</span>
                @if (listadoEventosGenericosVivoService.totalCount) {
                  <span class="badge">
                    {{ listadoEventosGenericosVivoService.totalCount }}
                  </span>
                }
              </span>
            </a>
          }

          <!-- Servicio Tecnico -->
          @if (helper.tieneModulo('Servicio Técnico')) {
            <mat-expansion-panel
              id="nav-panel-9"
              [expanded]="expandedPanel === 9"
              (opened)="expandedPanel = 9"
              (closed)="panelClosed(9)"
              (afterExpand)="scrollPanelIntoView('nav-panel-9')"
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>build</mat-icon>
                  Servicio Técnico
                  @if (pendientesServicioTecnico) {
                    <span class="badge">{{ pendientesServicioTecnico }}</span>
                  }
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="expansion-content">
                <!-- Mapa -->
                <!-- FALTA HACER PRUEBAS, NO TENGO TECNICOS CON VEHICULOS EN TEST :( -->
                <a
                  mat-list-item
                  routerLinkActive="active"
                  [routerLink]="['servicio-tecnico/mapa']"
                  [state]="estadoRaiz"
                >
                  <span class="nav-link">
                    <mat-icon matSuffix>map</mat-icon>
                    <span class="text-menu">Mapa</span>
                  </span>
                </a>
                <!-- Listado -->
                <a
                  mat-list-item
                  routerLinkActive="active"
                  [routerLink]="['servicio-tecnico/servicios-tecnicos']"
                  [state]="estadoRaiz"
                >
                  <span class="nav-link">
                    <mat-icon matSuffix>build</mat-icon>
                    <span class="text-menu">Servicios Técnicos</span>
                    @if (serviciosTecnicosPendientesService.totalCount) {
                      <span class="badge">
                        {{ serviciosTecnicosPendientesService.totalCount }}
                      </span>
                    }
                  </span>
                </a>
                <!-- Vehículos con función Servicio Técnico -->
                @if (helper.tieneModulo('Vehículos')) {
                  <a
                    mat-list-item
                    routerLinkActive="active"
                    [routerLink]="['vehiculos/servicio-tecnico']"
                    [state]="estadoRaiz"
                  >
                    <span class="nav-link">
                      <mat-icon matSuffix>directions_car</mat-icon>
                      <span class="text-menu">Vehículos</span>
                    </span>
                  </a>
                }
                <!-- Materiales (usados y pedidos de los ST) -->
                @if (
                  helper.tienePermiso(
                    'Servicio Técnico - Ver pedidos de materiales'
                  )
                ) {
                  <a
                    mat-list-item
                    routerLinkActive="active"
                    [routerLink]="['servicio-tecnico/pedidos-materiales']"
                    [state]="estadoRaiz"
                  >
                    <span class="nav-link">
                      <mat-icon matSuffix>inventory_2</mat-icon>
                      <span class="text-menu">Materiales</span>
                      @if (materialesPendientesService.totalCount) {
                        <span class="badge">
                          {{ materialesPendientesService.totalCount }}
                        </span>
                      }
                    </span>
                  </a>
                }
                <!-- Técnicos  -->
                @if (helper.tienePermiso('Servicio Técnico - Ver técnicos')) {
                  <a
                    mat-list-item
                    routerLinkActive="active"
                    [routerLink]="['administracion/tecnicos']"
                    [state]="estadoRaiz"
                  >
                    <span class="nav-link">
                      <mat-icon matSuffix>engineering</mat-icon>
                      <span class="text-menu">Técnicos</span>
                    </span>
                  </a>
                }
                <!-- Categorías  -->
                <a
                  mat-list-item
                  routerLinkActive="active"
                  [routerLink]="['administracion/categoriasServicioTecnico']"
                  [state]="estadoRaiz"
                >
                  <span class="nav-link">
                    <mat-icon matSuffix>category</mat-icon>
                    <span class="text-menu">Categorías</span>
                  </span>
                </a>
              </div>
            </mat-expansion-panel>
          }

          <!-- Alertas de Seguridad -->
          @if (helper.tieneModulo('Alertas de Seguridad')) {
            <mat-expansion-panel
              id="nav-panel-14"
              [expanded]="expandedPanel === 14"
              (opened)="expandedPanel = 14"
              (closed)="panelClosed(14)"
              (afterExpand)="scrollPanelIntoView('nav-panel-14')"
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>crisis_alert</mat-icon>
                  Alertas de Seguridad
                  @if (listadoAlertasSeguridadVivoService.totalCount) {
                    <span class="badge">
                      {{ listadoAlertasSeguridadVivoService.totalCount }}
                    </span>
                  }
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="expansion-content">
                <!-- Mapa -->
                <a
                  mat-list-item
                  routerLinkActive="active"
                  [routerLink]="['alertas-seguridad/mapa']"
                  [state]="estadoRaiz"
                >
                  <span class="nav-link">
                    <mat-icon matSuffix>map</mat-icon>
                    <span class="text-menu">Mapa</span>
                  </span>
                </a>
                <!-- Listado -->
                <a
                  mat-list-item
                  routerLinkActive="active"
                  [routerLink]="['alertas-seguridad/listado']"
                  [state]="estadoRaiz"
                >
                  <span class="nav-link">
                    <mat-icon matSuffix>list</mat-icon>
                    <span class="text-menu">Listado</span>
                  </span>
                </a>
                <!-- Vecinos -->
                <a
                  mat-list-item
                  routerLinkActive="active"
                  [routerLink]="['vecinos-seguridad/listado']"
                  [state]="estadoRaiz"
                >
                  <span class="nav-link">
                    <mat-icon matSuffix>groups</mat-icon>
                    <span class="text-menu">Vecinos</span>
                  </span>
                </a>
              </div>
            </mat-expansion-panel>
          }

          <mat-divider class="navigator-divider"></mat-divider>

          <!-- Modulos -->
          <!-- Barra de personalización del menú -->
          <div class="edit-mode-bar">
            <span class="edit-mode-title">
              @if (editMode) {
                Editando menú
              } @else {
                Módulos
              }
            </span>
            <button
              irxBotonIcono
              [tono]="editMode || hasHiddenModules ? 'primario' : 'neutro'"
              (click)="toggleEditMode()"
              [tooltip]="
                editMode
                  ? 'Finalizar edición'
                  : 'Personalizar orden y visibilidad'
              "
              class="edit-mode-btn"
            >
              <mat-icon>
                {{ editMode ? 'check_circle' : 'edit' }}
              </mat-icon>
            </button>
          </div>

          <div
            cdkDropList
            (cdkDropListDropped)="dropModulo($event)"
            class="modulos-drop-list"
          >
            @for (modulo of modulosOrdenados; track modulo.key) {
              @if (modulo.visible || editMode) {
                <div
                  cdkDrag
                  [cdkDragDisabled]="!editMode"
                  class="modulo-drag-item"
                  [class.modulo-oculto]="!modulo.visible"
                  [class.edit-active]="editMode"
                >
                  @if (editMode) {
                    <div class="drag-edit-controls">
                      <button
                        irxBotonIcono
                        cdkDragHandle
                        class="drag-handle-btn"
                        tooltip="Arrastrar para reordenar"
                      >
                        <mat-icon>drag_indicator</mat-icon>
                      </button>
                      <button
                        irxBotonIcono
                        [tono]="modulo.visible ? 'neutro' : 'peligro'"
                        (click)="toggleVisibility(modulo.key)"
                        [tooltip]="
                          modulo.visible ? 'Ocultar módulo' : 'Mostrar módulo'
                        "
                      >
                        <mat-icon>
                          {{ modulo.visible ? 'visibility' : 'visibility_off' }}
                        </mat-icon>
                      </button>
                    </div>
                  }
                  <div class="modulo-panel-wrapper">
                    @switch (modulo.key) {
                      @case ('alarmas') {
                        <mat-expansion-panel
                          id="nav-panel-1"
                          [expanded]="expandedPanel === 1"
                          (opened)="expandedPanel = 1"
                          (closed)="panelClosed(1)"
                          (afterExpand)="scrollPanelIntoView('nav-panel-1')"
                        >
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              <mat-icon>doorbell</mat-icon>
                              Alarmas
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <!-- Mapa -->
                          <a
                            mat-list-item
                            routerLinkActive="active"
                            [routerLink]="['alarmas/mapa']"
                            [state]="estadoRaiz"
                          >
                            <span class="nav-link">
                              <mat-icon matSuffix>map</mat-icon>
                              <span class="text-menu">Mapa</span>
                            </span>
                          </a>
                          <!-- Alarma Domiciliaria -->
                          <a
                            mat-list-item
                            routerLinkActive="active"
                            [routerLink]="['alarmas/alarmasDomiciliarias']"
                            [state]="estadoRaiz"
                          >
                            <span class="nav-link">
                              <mat-icon matSuffix>doorbell</mat-icon>
                              <span class="text-menu">
                                Alarmas Domiciliarias
                              </span>
                            </span>
                          </a>
                          <!-- Zonas geográficas -->
                          <a
                            mat-list-item
                            routerLinkActive="active"
                            [routerLink]="['alarmas/zonas/Alarmas']"
                            [state]="estadoRaiz"
                          >
                            <span class="nav-link">
                              <mat-icon matSuffix>crop_free</mat-icon>
                              <span class="text-menu">Zonas</span>
                            </span>
                          </a>

                          <!-- Toggle configuración alarmas -->
                          <button
                            mat-list-item
                            (click)="showAlarmaConfig = !showAlarmaConfig"
                            class="nav-toggle-btn irx-nav"
                          >
                            <span class="nav-link">
                              <mat-icon matSuffix>
                                {{
                                  showAlarmaConfig
                                    ? 'expand_less'
                                    : 'expand_more'
                                }}
                              </mat-icon>
                              <span class="text-menu">Configuración</span>
                            </span>
                          </button>

                          @if (showAlarmaConfig) {
                            <!-- Codigos Alarmas -->
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="[
                                'configuracion/codigosDispositivos/Alarma',
                              ]"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>
                                  integration_instructions
                                </mat-icon>
                                <span class="text-menu">Códigos Alarmas</span>
                              </span>
                            </a>

                            <!-- Modelos Alarma -->
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="[
                                'configuracion/modelosDispositivos/Alarma',
                              ]"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>memory</mat-icon>
                                <span class="text-menu">Modelos Alarmas</span>
                              </span>
                            </a>

                            <!-- Codigos Comunicadores -->
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="[
                                'configuracion/codigosDispositivos/Comunicador',
                              ]"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>
                                  integration_instructions
                                </mat-icon>
                                <span class="text-menu">
                                  Códigos Comunicadores
                                </span>
                              </span>
                            </a>

                            <!-- Modelos Comunicadores -->
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="[
                                'configuracion/modelosDispositivos/Comunicador',
                              ]"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>memory</mat-icon>
                                <span class="text-menu">
                                  Modelos Comunicadores
                                </span>
                              </span>
                            </a>
                          }
                        </mat-expansion-panel>
                      }
                      @case ('camaras') {
                        <mat-expansion-panel
                          id="nav-panel-2"
                          [expanded]="expandedPanel === 2"
                          (opened)="expandedPanel = 2"
                          (closed)="panelClosed(2)"
                          (afterExpand)="scrollPanelIntoView('nav-panel-2')"
                        >
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              <mat-icon>videocam</mat-icon>
                              Cámaras
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <!-- Cámaras -->
                          <a
                            mat-list-item
                            routerLinkActive="active"
                            [routerLink]="['camaras']"
                            [state]="estadoRaiz"
                          >
                            <span class="nav-link">
                              <mat-icon matSuffix>videocam</mat-icon>
                              <span class="text-menu">Cámaras</span>
                            </span>
                          </a>

                          <!-- Toggle configuración cámaras -->
                          <button
                            mat-list-item
                            (click)="showCamaraConfig = !showCamaraConfig"
                            class="nav-toggle-btn irx-nav"
                          >
                            <span class="nav-link">
                              <mat-icon matSuffix>
                                {{
                                  showCamaraConfig
                                    ? 'expand_less'
                                    : 'expand_more'
                                }}
                              </mat-icon>
                              <span class="text-menu">Configuración</span>
                            </span>
                          </button>

                          @if (showCamaraConfig) {
                            <!-- Modelos Cámaras -->
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="[
                                'configuracion/modelosDispositivos/Cámara',
                              ]"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>memory</mat-icon>
                                <span class="text-menu">Modelos Cámaras</span>
                              </span>
                            </a>

                            <!-- Modelos NVR -->
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="[
                                'configuracion/modelosDispositivos/NVR',
                              ]"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>memory</mat-icon>
                                <span class="text-menu">Modelos NVR</span>
                              </span>
                            </a>
                          }
                        </mat-expansion-panel>
                      }

                      @case ('emergencias-medicas') {
                        <mat-expansion-panel
                          id="nav-panel-5"
                          [expanded]="expandedPanel === 5"
                          (opened)="expandedPanel = 5"
                          (closed)="panelClosed(5)"
                          (afterExpand)="scrollPanelIntoView('nav-panel-5')"
                        >
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              <mat-icon>emergency</mat-icon>
                              Emergencias Médicas
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <div class="expansion-content">
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="[
                                'emergencias/mapaEmergenciasMedicas',
                              ]"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>map</mat-icon>
                                <span class="text-menu">Mapa</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['emergencias/emergenciasMedicas']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>
                                  <span class="material-icons-outlined">
                                    emergency
                                  </span>
                                </mat-icon>
                                <span class="text-menu">Emergencias</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['emergencias/tableroMedico']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>dashboard</mat-icon>
                                <span class="text-menu">Dashboard</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['emergencias/hospitales']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>local_hospital</mat-icon>
                                <span class="text-menu">Hospitales</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="[
                                'emergencias/centrosAtencion/medica',
                              ]"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>apartment</mat-icon>
                                <span class="text-menu">
                                  Bases de operaciones
                                </span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['emergencias/personalesSalud']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>
                                  <span class="material-icons-outlined">
                                    medical_services
                                  </span>
                                </mat-icon>
                                <span class="text-menu">Personal de salud</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['emergencias/solicitantes']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>
                                  person_raised_hand
                                </mat-icon>
                                <span class="text-menu">Solicitantes</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="[
                                'emergencias/destinatariosAsistencia/medica',
                              ]"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>personal_injury</mat-icon>
                                <span class="text-menu">Pacientes</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['emergencias/categoriasMedicas']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>
                                  medical_information
                                </mat-icon>
                                <span class="text-menu">
                                  Síntomas y diagnósticos
                                </span>
                              </span>
                            </a>
                          </div>
                        </mat-expansion-panel>
                      }
                      @case ('activos') {
                        <mat-expansion-panel
                          id="nav-panel-6"
                          [expanded]="expandedPanel === 6"
                          (opened)="expandedPanel = 6"
                          (closed)="panelClosed(6)"
                          (afterExpand)="scrollPanelIntoView('nav-panel-6')"
                        >
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              <mat-icon>assistant_navigation</mat-icon>
                              Gestión de Activos
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <div class="expansion-content">
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['activos/mapa']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>map</mat-icon>
                                <span class="text-menu">Mapa</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['activos/activos']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>
                                  assistant_navigation
                                </mat-icon>
                                <span class="text-menu">Activos</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['activos/ubicaciones/Activos']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>crop_free</mat-icon>
                                <span class="text-menu">Ubicaciones</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['activos/grupos/Activo']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>workspaces</mat-icon>
                                <span class="text-menu">Agrupaciones</span>
                              </span>
                            </a>

                            @if (
                              helper.tienePermiso(
                                'Administración - Ver trackers'
                              )
                            ) {
                              <!-- Toggle configuración activos -->
                              <button
                                mat-list-item
                                (click)="showActivoConfig = !showActivoConfig"
                                class="nav-toggle-btn irx-nav"
                              >
                                <span class="nav-link">
                                  <mat-icon matSuffix>
                                    {{
                                      showActivoConfig
                                        ? 'expand_less'
                                        : 'expand_more'
                                    }}
                                  </mat-icon>
                                  <span class="text-menu">Configuración</span>
                                </span>
                              </button>

                              @if (showActivoConfig) {
                                <!-- Códigos Trackers -->
                                <a
                                  mat-list-item
                                  routerLinkActive="active"
                                  [routerLink]="[
                                    'configuracion/codigosDispositivos/Tracker',
                                  ]"
                                  [state]="estadoRaiz"
                                >
                                  <span class="nav-link">
                                    <mat-icon matSuffix>
                                      integration_instructions
                                    </mat-icon>
                                    <span class="text-menu">
                                      Códigos Trackers
                                    </span>
                                  </span>
                                </a>

                                <!-- Modelos Trackers -->
                                <a
                                  mat-list-item
                                  routerLinkActive="active"
                                  [routerLink]="[
                                    'configuracion/modelosDispositivos/Tracker',
                                  ]"
                                  [state]="estadoRaiz"
                                >
                                  <span class="nav-link">
                                    <mat-icon matSuffix>memory</mat-icon>
                                    <span class="text-menu">
                                      Modelos Trackers
                                    </span>
                                  </span>
                                </a>

                                <!-- Códigos y modelos de Dashcams -->
                                @if (
                                  helper.tienePermiso(
                                    'Administración - Ver dashcams'
                                  )
                                ) {
                                  <a
                                    mat-list-item
                                    routerLinkActive="active"
                                    [routerLink]="[
                                      'configuracion/codigosDispositivos/Dashcam',
                                    ]"
                                    [state]="estadoRaiz"
                                  >
                                    <span class="nav-link">
                                      <mat-icon matSuffix>
                                        integration_instructions
                                      </mat-icon>
                                      <span class="text-menu">
                                        Códigos Dashcams
                                      </span>
                                    </span>
                                  </a>

                                  <a
                                    mat-list-item
                                    routerLinkActive="active"
                                    [routerLink]="[
                                      'configuracion/modelosDispositivos/Dashcam',
                                    ]"
                                    [state]="estadoRaiz"
                                  >
                                    <span class="nav-link">
                                      <mat-icon matSuffix>memory</mat-icon>
                                      <span class="text-menu">
                                        Modelos Dashcams
                                      </span>
                                    </span>
                                  </a>
                                }
                              }
                            }
                          </div>
                        </mat-expansion-panel>
                      }
                      @case ('logs') {
                        <mat-expansion-panel
                          id="nav-panel-7"
                          [expanded]="expandedPanel === 7"
                          (opened)="expandedPanel = 7"
                          (closed)="panelClosed(7)"
                          (afterExpand)="scrollPanelIntoView('nav-panel-7')"
                        >
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              <mat-icon>terminal</mat-icon>
                              Logs
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <div class="expansion-content">
                            @if (helper.tienePermiso('Logs - Ver logs http')) {
                              <a
                                mat-list-item
                                routerLinkActive="active"
                                [routerLink]="['logs/requesthttp']"
                                [state]="estadoRaiz"
                              >
                                <span class="nav-link">
                                  <mat-icon matSuffix>http</mat-icon>
                                  <span class="text-menu">Requests Http</span>
                                </span>
                              </a>
                            }
                            @if (
                              helper.tienePermiso(
                                'Logs - Ver logs eventos lora'
                              )
                            ) {
                              <a
                                mat-list-item
                                routerLinkActive="active"
                                [routerLink]="['logs/eventosmqtt']"
                                [state]="estadoRaiz"
                              >
                                <span class="nav-link">
                                  <mat-icon matSuffix>wifi_tethering</mat-icon>
                                  <span class="text-menu">Eventos Lorawan</span>
                                </span>
                              </a>
                            }
                            @if (
                              helper.tienePermiso('Logs - Ver logs despachos')
                            ) {
                              <a
                                mat-list-item
                                routerLinkActive="active"
                                [routerLink]="['administracion/logsdespachos']"
                                [state]="estadoRaiz"
                              >
                                <span class="nav-link">
                                  <mat-icon matSuffix>departure_board</mat-icon>
                                  <span class="text-menu">Logs Despachos</span>
                                </span>
                              </a>
                            }
                            @if (
                              helper.tienePermiso(
                                'Logs - Ver logs eventos trackers test'
                              )
                            ) {
                              <a
                                mat-list-item
                                routerLinkActive="active"
                                [routerLink]="['logs/logsmensajestest']"
                                [state]="estadoRaiz"
                              >
                                <span class="nav-link">
                                  <mat-icon matSuffix>science</mat-icon>
                                  <span class="text-menu">Logs Test</span>
                                </span>
                              </a>
                            }
                            @if (
                              helper.tienePermiso('Logs - Ver logs reenvios')
                            ) {
                              <a
                                mat-list-item
                                routerLinkActive="active"
                                [routerLink]="['administracion/log-reenvios']"
                                [state]="estadoRaiz"
                              >
                                <span class="nav-link">
                                  <mat-icon matSuffix>
                                    forward_to_inbox
                                  </mat-icon>
                                  <span class="text-menu">Log Reenvíos</span>
                                </span>
                              </a>
                            }
                            @if (
                              helper.tienePermiso(
                                'Logs - Ver métricas downlinks'
                              )
                            ) {
                              <a
                                mat-list-item
                                routerLinkActive="active"
                                [routerLink]="['logs/metricas-cola']"
                                [state]="estadoRaiz"
                              >
                                <span class="nav-link">
                                  <mat-icon matSuffix>analytics</mat-icon>
                                  <span class="text-menu">
                                    Métricas de Downlinks
                                  </span>
                                </span>
                              </a>
                            }
                          </div>
                        </mat-expansion-panel>
                      }
                      @case ('luminarias') {
                        <mat-expansion-panel
                          id="nav-panel-8"
                          [expanded]="expandedPanel === 8"
                          (opened)="expandedPanel = 8"
                          (closed)="panelClosed(8)"
                          (afterExpand)="scrollPanelIntoView('nav-panel-8')"
                        >
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              <mat-icon>lightbulb</mat-icon>
                              Luminarias Municipales
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <div class="expansion-content">
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['luminarias/dashboard']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>dashboard</mat-icon>
                                <span class="text-menu">Dashboard</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['luminarias/mapa']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>map</mat-icon>
                                <span class="text-menu">Mapa</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['luminarias/luminarias']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>lightbulb</mat-icon>
                                <span class="text-menu">Luminarias</span>
                              </span>
                            </a>
                            @if (
                              clientePropio?.config?.moduloLuminarias
                                ?.usaPuestas
                            ) {
                              <a
                                mat-list-item
                                routerLinkActive="active"
                                [routerLink]="['luminarias/puestas']"
                                [state]="estadoRaiz"
                              >
                                <span class="nav-link">
                                  <mat-icon matSuffix>table_lamp</mat-icon>
                                  <span class="text-menu">Puestas</span>
                                </span>
                              </a>
                            }

                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['luminarias/grupos/Luminaria']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>workspaces</mat-icon>
                                <span class="text-menu">
                                  Grupos de Luminarias
                                </span>
                              </span>
                            </a>
                            @if (
                              clientePropio?.config?.moduloLuminarias
                                ?.usaPuestas
                            ) {
                              <a
                                mat-list-item
                                routerLinkActive="active"
                                [routerLink]="['luminarias/grupos/Puesta']"
                                [state]="estadoRaiz"
                              >
                                <span class="nav-link">
                                  <mat-icon matSuffix>hub</mat-icon>
                                  <span class="text-menu">
                                    Grupos de puestas
                                  </span>
                                </span>
                              </a>
                            }
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['luminarias/zonas/Luminarias']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>crop_free</mat-icon>
                                <span class="text-menu">Zonas</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['luminarias/seguimiento']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>track_changes</mat-icon>
                                <span class="text-menu">Seguimiento</span>
                              </span>
                            </a>

                            <!-- Toggle configuración luminarias -->
                            <button
                              mat-list-item
                              (click)="
                                showLuminariaConfig = !showLuminariaConfig
                              "
                              class="nav-toggle-btn irx-nav"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>
                                  {{
                                    showLuminariaConfig
                                      ? 'expand_less'
                                      : 'expand_more'
                                  }}
                                </mat-icon>
                                <span class="text-menu">Configuración</span>
                              </span>
                            </button>

                            @if (showLuminariaConfig) {
                              <!-- Modelos Luminarias -->
                              <a
                                mat-list-item
                                routerLinkActive="active"
                                [routerLink]="[
                                  'configuracion/modelosDispositivos/Luminaria',
                                ]"
                                [state]="estadoRaiz"
                              >
                                <span class="nav-link">
                                  <mat-icon matSuffix>memory</mat-icon>
                                  <span class="text-menu">
                                    Modelos Luminarias
                                  </span>
                                </span>
                              </a>

                              <!-- Configuración de Perfiles -->
                              <a
                                mat-list-item
                                routerLinkActive="active"
                                [routerLink]="[
                                  'configuracion/configsPerfiles/Luminaria',
                                ]"
                                [state]="estadoRaiz"
                              >
                                <span class="nav-link">
                                  <mat-icon matSuffix>tune</mat-icon>
                                  <span class="text-menu">
                                    Configuración de Perfiles
                                  </span>
                                </span>
                              </a>

                              @if (
                                helper.tienePermiso(
                                  'Administración - Ver dispositivos Lorawan'
                                )
                              ) {
                                <!-- Códigos Dispositivos Lorawan -->
                                <a
                                  mat-list-item
                                  routerLinkActive="active"
                                  [routerLink]="[
                                    'configuracion/codigosDispositivos/DispositivoLorawan',
                                  ]"
                                  [state]="estadoRaiz"
                                >
                                  <span class="nav-link">
                                    <mat-icon matSuffix>
                                      integration_instructions
                                    </mat-icon>
                                    <span class="text-menu">
                                      Códigos Dispositivos Lorawan
                                    </span>
                                  </span>
                                </a>

                                <!-- Modelos Dispositivos Lorawan -->
                                <a
                                  mat-list-item
                                  routerLinkActive="active"
                                  [routerLink]="[
                                    'configuracion/modelosDispositivos/DispositivoLorawan',
                                  ]"
                                  [state]="estadoRaiz"
                                >
                                  <span class="nav-link">
                                    <mat-icon matSuffix>memory</mat-icon>
                                    <span class="text-menu">
                                      Modelos Dispositivos Lorawan
                                    </span>
                                  </span>
                                </a>
                              }

                              @if (
                                helper.tienePermiso(
                                  'Administración - Ver botones Ble'
                                )
                              ) {
                                <!-- Códigos Botones BLE -->
                                <a
                                  mat-list-item
                                  routerLinkActive="active"
                                  [routerLink]="[
                                    'configuracion/codigosDispositivos/BotonBLE',
                                  ]"
                                  [state]="estadoRaiz"
                                >
                                  <span class="nav-link">
                                    <mat-icon matSuffix>
                                      integration_instructions
                                    </mat-icon>
                                    <span class="text-menu">
                                      Códigos Botones BLE
                                    </span>
                                  </span>
                                </a>

                                <!-- Modelos Botones BLE -->
                                <a
                                  mat-list-item
                                  routerLinkActive="active"
                                  [routerLink]="[
                                    'configuracion/modelosDispositivos/BotonBLE',
                                  ]"
                                  [state]="estadoRaiz"
                                >
                                  <span class="nav-link">
                                    <mat-icon matSuffix>memory</mat-icon>
                                    <span class="text-menu">
                                      Modelos Botones BLE
                                    </span>
                                  </span>
                                </a>
                              }

                              <!-- Dispositivos Lorawan  -->
                              @if (
                                helper.tienePermiso(
                                  'Administración - Ver dispositivos Lorawan'
                                )
                              ) {
                                <a
                                  mat-list-item
                                  routerLinkActive="active"
                                  [routerLink]="[
                                    'administracion/dispositivoslorawan',
                                  ]"
                                  [state]="estadoRaiz"
                                >
                                  <span class="nav-link">
                                    <mat-icon matSuffix>router</mat-icon>
                                    <span class="text-menu">
                                      Dispositivos Lorawan
                                    </span>
                                  </span>
                                </a>
                              }

                              <!-- Gateways  -->
                              @if (
                                helper.tienePermiso(
                                  'Administración - Ver gateways'
                                )
                              ) {
                                <a
                                  mat-list-item
                                  routerLinkActive="active"
                                  [routerLink]="['administracion/gateways']"
                                  [state]="estadoRaiz"
                                >
                                  <span class="nav-link">
                                    <mat-icon matSuffix>podcasts</mat-icon>
                                    <span class="text-menu">Gateways</span>
                                  </span>
                                </a>
                              }

                              <!-- Botones BLE -->
                              @if (
                                helper.tienePermiso(
                                  'Administración - Ver botones Ble'
                                )
                              ) {
                                <a
                                  mat-list-item
                                  routerLinkActive="active"
                                  [routerLink]="['administracion/botones-ble']"
                                  [state]="estadoRaiz"
                                >
                                  <span class="nav-link">
                                    <mat-icon matSuffix>touch_app</mat-icon>
                                    <span class="text-menu">Botones BLE</span>
                                  </span>
                                </a>
                              }
                            }
                          </div>
                        </mat-expansion-panel>
                      }
                      @case ('facturacion') {
                        <mat-expansion-panel
                          id="nav-panel-15"
                          [expanded]="expandedPanel === 15"
                          (opened)="expandedPanel = 15"
                          (closed)="panelClosed(15)"
                          (afterExpand)="scrollPanelIntoView('nav-panel-15')"
                        >
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              <mat-icon>receipt_long</mat-icon>
                              Facturación
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <div class="expansion-content">
                            @for (s of seccionesFacturacion; track s.ruta) {
                              <a
                                mat-list-item
                                routerLinkActive="active"
                                [routerLink]="['facturacion-v2', s.ruta]"
                                [state]="estadoRaiz"
                              >
                                <span class="nav-link">
                                  <mat-icon matSuffix>{{ s.icono }}</mat-icon>
                                  <span class="text-menu">{{ s.label }}</span>
                                </span>
                              </a>
                            }
                          </div>
                        </mat-expansion-panel>
                      }
                      @case ('sirenas') {
                        <mat-expansion-panel
                          id="nav-panel-10"
                          [expanded]="expandedPanel === 10"
                          (opened)="expandedPanel = 10"
                          (closed)="panelClosed(10)"
                          (afterExpand)="scrollPanelIntoView('nav-panel-10')"
                        >
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              <mat-icon>campaign</mat-icon>
                              Sirenas Municipales
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <div class="expansion-content">
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['sirenas/mapa']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>map</mat-icon>
                                <span class="text-menu">Mapa</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['sirenas/sirenas']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>campaign</mat-icon>
                                <span class="text-menu">Sirenas</span>
                              </span>
                            </a>

                            <!-- Toggle configuración sirenas -->
                            <button
                              mat-list-item
                              (click)="showSirenaConfig = !showSirenaConfig"
                              class="nav-toggle-btn irx-nav"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>
                                  {{
                                    showSirenaConfig
                                      ? 'expand_less'
                                      : 'expand_more'
                                  }}
                                </mat-icon>
                                <span class="text-menu">Configuración</span>
                              </span>
                            </button>

                            @if (showSirenaConfig) {
                              <!-- Códigos Sirenas -->
                              <a
                                mat-list-item
                                routerLinkActive="active"
                                [routerLink]="[
                                  'configuracion/codigosDispositivos/Sirena',
                                ]"
                                [state]="estadoRaiz"
                              >
                                <span class="nav-link">
                                  <mat-icon matSuffix>
                                    integration_instructions
                                  </mat-icon>
                                  <span class="text-menu">Códigos Sirenas</span>
                                </span>
                              </a>

                              <!-- Modelos Sirenas -->
                              <a
                                mat-list-item
                                routerLinkActive="active"
                                [routerLink]="[
                                  'configuracion/modelosDispositivos/Sirena',
                                ]"
                                [state]="estadoRaiz"
                              >
                                <span class="nav-link">
                                  <mat-icon matSuffix>memory</mat-icon>
                                  <span class="text-menu">Modelos Sirenas</span>
                                </span>
                              </a>
                            }
                          </div>
                        </mat-expansion-panel>
                      }
                      @case ('colectivos') {
                        <mat-expansion-panel
                          id="nav-panel-11"
                          [expanded]="expandedPanel === 11"
                          (opened)="expandedPanel = 11"
                          (closed)="panelClosed(11)"
                          (afterExpand)="scrollPanelIntoView('nav-panel-11')"
                        >
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              <mat-icon>directions_bus</mat-icon>
                              Transporte Público
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <div class="expansion-content">
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['colectivos/mapaColectivos']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>map</mat-icon>
                                <span class="text-menu">Mapa</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['colectivos/colectivos']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>directions_bus</mat-icon>
                                <span class="text-menu">Colectivos</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['colectivos/despachos']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>departure_board</mat-icon>
                                <span class="text-menu">Despachos</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['colectivos/recorridos']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>route</mat-icon>
                                <span class="text-menu">Recorridos</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['colectivos/ubicaciones/Terminal']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>
                                  emoji_transportation
                                </mat-icon>
                                <span class="text-menu">Terminales</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="[
                                'colectivos/grupos/Línea de colectivo',
                              ]"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>workspaces</mat-icon>
                                <span class="text-menu">Líneas</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['colectivos/choferes']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>account_box</mat-icon>
                                <span class="text-menu">Choferes</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['colectivos/cronogramas']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>
                                  calendar_view_month
                                </mat-icon>
                                Cronogramas
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="[
                                'colectivos/recordatorios/Colectivo',
                              ]"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>alarm</mat-icon>
                                <span class="text-menu">Recordatorios</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['colectivos/servicios/Colectivo']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>
                                  home_repair_service
                                </mat-icon>
                                Servicios
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="[
                                'colectivos/proveedores/Colectivo',
                              ]"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>storefront</mat-icon>
                                <span class="text-menu">Proveedores</span>
                              </span>
                            </a>

                            @if (
                              helper.tienePermiso(
                                'Administración - Ver trackers'
                              )
                            ) {
                              <!-- Toggle configuración colectivos -->
                              <button
                                mat-list-item
                                (click)="
                                  showColectivoConfig = !showColectivoConfig
                                "
                                class="nav-toggle-btn irx-nav"
                              >
                                <span class="nav-link">
                                  <mat-icon matSuffix>
                                    {{
                                      showColectivoConfig
                                        ? 'expand_less'
                                        : 'expand_more'
                                    }}
                                  </mat-icon>
                                  <span class="text-menu">Configuración</span>
                                </span>
                              </button>

                              @if (showColectivoConfig) {
                                <!-- Códigos Trackers -->
                                <a
                                  mat-list-item
                                  routerLinkActive="active"
                                  [routerLink]="[
                                    'configuracion/codigosDispositivos/Tracker',
                                  ]"
                                  [state]="estadoRaiz"
                                >
                                  <span class="nav-link">
                                    <mat-icon matSuffix>
                                      integration_instructions
                                    </mat-icon>
                                    <span class="text-menu">
                                      Códigos Trackers
                                    </span>
                                  </span>
                                </a>

                                <!-- Modelos Trackers -->
                                <a
                                  mat-list-item
                                  routerLinkActive="active"
                                  [routerLink]="[
                                    'configuracion/modelosDispositivos/Tracker',
                                  ]"
                                  [state]="estadoRaiz"
                                >
                                  <span class="nav-link">
                                    <mat-icon matSuffix>memory</mat-icon>
                                    <span class="text-menu">
                                      Modelos Trackers
                                    </span>
                                  </span>
                                </a>

                                <!-- Códigos y modelos de Dashcams -->
                                @if (
                                  helper.tienePermiso(
                                    'Administración - Ver dashcams'
                                  )
                                ) {
                                  <a
                                    mat-list-item
                                    routerLinkActive="active"
                                    [routerLink]="[
                                      'configuracion/codigosDispositivos/Dashcam',
                                    ]"
                                    [state]="estadoRaiz"
                                  >
                                    <span class="nav-link">
                                      <mat-icon matSuffix>
                                        integration_instructions
                                      </mat-icon>
                                      <span class="text-menu">
                                        Códigos Dashcams
                                      </span>
                                    </span>
                                  </a>

                                  <a
                                    mat-list-item
                                    routerLinkActive="active"
                                    [routerLink]="[
                                      'configuracion/modelosDispositivos/Dashcam',
                                    ]"
                                    [state]="estadoRaiz"
                                  >
                                    <span class="nav-link">
                                      <mat-icon matSuffix>memory</mat-icon>
                                      <span class="text-menu">
                                        Modelos Dashcams
                                      </span>
                                    </span>
                                  </a>
                                }
                              }
                            }
                          </div>
                        </mat-expansion-panel>
                      }
                      @case ('vehiculos') {
                        <mat-expansion-panel
                          id="nav-panel-12"
                          [expanded]="expandedPanel === 12"
                          (opened)="expandedPanel = 12"
                          (closed)="panelClosed(12)"
                          (afterExpand)="scrollPanelIntoView('nav-panel-12')"
                        >
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              <mat-icon>directions_car</mat-icon>
                              Vehículos
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <div class="expansion-content">
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['vehiculos/dashboard']"
                              [state]="estadoRaiz"
                              (click)="toggleSidenav()"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>dashboard</mat-icon>
                                <span class="text-menu">Dashboard</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['vehiculos/mapa']"
                              [state]="estadoRaiz"
                              (click)="toggleSidenav()"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>map</mat-icon>
                                <span class="text-menu">Mapa</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['vehiculos/vehiculos']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>directions_car</mat-icon>
                                <span class="text-menu">Vehículos</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['vehiculos/conductores']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>account_box</mat-icon>
                                <span class="text-menu">Conductores</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['vehiculos/ubicaciones/Vehiculos']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>crop_free</mat-icon>
                                <span class="text-menu">
                                  Ubicaciones/
                                  <wbr />
                                  Zonas
                                </span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['vehiculos/recorridos']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>route</mat-icon>
                                <span class="text-menu">Recorridos</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['vehiculos/recorridos-dinamicos']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>alt_route</mat-icon>
                                <span class="text-menu">
                                  Recorridos dinámicos
                                </span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['vehiculos/grupos/Flota']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>workspaces</mat-icon>
                                <span class="text-menu">Flota</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="[
                                'colectivos/recordatorios/Vehiculo',
                              ]"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>alarm</mat-icon>
                                <span class="text-menu">Recordatorios</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['vehiculos/servicios/Vehiculo']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>
                                  home_repair_service
                                </mat-icon>
                                Servicios
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['colectivos/proveedores/Vehiculo']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>storefront</mat-icon>
                                <span class="text-menu">Proveedores</span>
                              </span>
                            </a>
                            <a
                              mat-list-item
                              routerLinkActive="active"
                              [routerLink]="['vehiculos/enviosVehiculos']"
                              [state]="estadoRaiz"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>local_shipping</mat-icon>
                                <span class="text-menu">Envíos Vehículos</span>
                              </span>
                            </a>

                            <!-- Toggle configuración vehículos -->
                            <button
                              mat-list-item
                              (click)="showVehiculoConfig = !showVehiculoConfig"
                              class="nav-toggle-btn irx-nav"
                            >
                              <span class="nav-link">
                                <mat-icon matSuffix>
                                  {{
                                    showVehiculoConfig
                                      ? 'expand_less'
                                      : 'expand_more'
                                  }}
                                </mat-icon>
                                <span class="text-menu">Configuración</span>
                              </span>
                            </button>

                            @if (showVehiculoConfig) {
                              <!-- Íconos Vehículos -->
                              <a
                                mat-list-item
                                routerLinkActive="active"
                                [routerLink]="[
                                  'configuracion/markersVehiculos',
                                ]"
                                [state]="estadoRaiz"
                              >
                                <span class="nav-link">
                                  <mat-icon matSuffix>interests</mat-icon>
                                  <span class="text-menu">
                                    Íconos Vehículos
                                  </span>
                                </span>
                              </a>

                              @if (
                                helper.tienePermiso(
                                  'Administración - Ver trackers'
                                )
                              ) {
                                <!-- Códigos Trackers -->
                                <a
                                  mat-list-item
                                  routerLinkActive="active"
                                  [routerLink]="[
                                    'configuracion/codigosDispositivos/Tracker',
                                  ]"
                                  [state]="estadoRaiz"
                                >
                                  <span class="nav-link">
                                    <mat-icon matSuffix>
                                      integration_instructions
                                    </mat-icon>
                                    <span class="text-menu">
                                      Códigos Trackers
                                    </span>
                                  </span>
                                </a>

                                <!-- Modelos Trackers -->
                                <a
                                  mat-list-item
                                  routerLinkActive="active"
                                  [routerLink]="[
                                    'configuracion/modelosDispositivos/Tracker',
                                  ]"
                                  [state]="estadoRaiz"
                                >
                                  <span class="nav-link">
                                    <mat-icon matSuffix>memory</mat-icon>
                                    <span class="text-menu">
                                      Modelos Trackers
                                    </span>
                                  </span>
                                </a>

                                <!-- Códigos y modelos de Dashcams -->
                                @if (
                                  helper.tienePermiso(
                                    'Administración - Ver dashcams'
                                  )
                                ) {
                                  <a
                                    mat-list-item
                                    routerLinkActive="active"
                                    [routerLink]="[
                                      'configuracion/codigosDispositivos/Dashcam',
                                    ]"
                                    [state]="estadoRaiz"
                                  >
                                    <span class="nav-link">
                                      <mat-icon matSuffix>
                                        integration_instructions
                                      </mat-icon>
                                      <span class="text-menu">
                                        Códigos Dashcams
                                      </span>
                                    </span>
                                  </a>

                                  <a
                                    mat-list-item
                                    routerLinkActive="active"
                                    [routerLink]="[
                                      'configuracion/modelosDispositivos/Dashcam',
                                    ]"
                                    [state]="estadoRaiz"
                                  >
                                    <span class="nav-link">
                                      <mat-icon matSuffix>memory</mat-icon>
                                      <span class="text-menu">
                                        Modelos Dashcams
                                      </span>
                                    </span>
                                  </a>
                                }
                              }
                            }
                          </div>
                        </mat-expansion-panel>
                      }
                    }
                  </div>
                </div>
              }
            }
          </div>

          <br />

          <mat-accordion displayMode="flat">
            <!-- Administracion -->
            @if (helper.tieneModulo('Administración')) {
              <mat-expansion-panel
                id="nav-panel-0"
                [expanded]="expandedPanel === 0"
                (opened)="expandedPanel = 0"
                (closed)="panelClosed(0)"
                (afterExpand)="scrollPanelIntoView('nav-panel-0')"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mat-icon>admin_panel_settings</mat-icon>
                    Administración
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <!-- Contenido de administracion -->
                <div class="expansion-content">
                  <!-- Facturación (solo cliente nivel 0 según el permiso activo) -->
                  @if (helper.esClienteNivel0()) {
                    <a
                      mat-list-item
                      routerLinkActive="active"
                      [routerLink]="['facturacion']"
                      [state]="estadoRaiz"
                    >
                      <span class="nav-link">
                        <mat-icon matSuffix>receipt_long</mat-icon>
                        <span class="text-menu">Facturación</span>
                      </span>
                    </a>
                  }
                  <!-- Gastos (nivel 1 o raíz independiente, rol Administrador) -->
                  @if (verGastos) {
                    <a
                      mat-list-item
                      routerLinkActive="active"
                      [routerLink]="['gastos']"
                      [state]="estadoRaiz"
                    >
                      <span class="nav-link">
                        <mat-icon matSuffix>payments</mat-icon>
                        <span class="text-menu">Gastos</span>
                      </span>
                    </a>
                  }

                  @if (
                    helper.tienePermiso('Administración - Ver clientes') &&
                    !helper.esClienteFinal()
                  ) {
                    <a
                      mat-list-item
                      routerLinkActive="active"
                      [routerLink]="['administracion/clientes']"
                      [state]="estadoRaiz"
                    >
                      <span class="nav-link">
                        <mat-icon matSuffix>business</mat-icon>
                        <span class="text-menu">Clientes</span>
                      </span>
                    </a>
                  }
                  <!-- Buscar por teléfono -->
                  <a
                    mat-list-item
                    routerLinkActive="active"
                    [routerLink]="['administracion/buscar-telefono']"
                    [state]="estadoRaiz"
                  >
                    <span class="nav-link">
                      <mat-icon matSuffix>phone</mat-icon>
                      <span class="text-menu">Buscar por teléfono</span>
                    </span>
                  </a>
                  <!-- Permisos -->
                  @if (helper.tienePermiso('Administración - Ver usuarios')) {
                    <a
                      mat-list-item
                      routerLinkActive="active"
                      [routerLink]="['administracion/usuarios']"
                      [state]="estadoRaiz"
                    >
                      <span class="nav-link">
                        <mat-icon matSuffix>security</mat-icon>
                        <span class="text-menu">Permisos</span>
                      </span>
                    </a>
                  }

                  <!-- Roles -->
                  @if (helper.tienePermiso('Administración - Ver roles')) {
                    <a
                      mat-list-item
                      routerLinkActive="active"
                      [routerLink]="['administracion/roles']"
                      [state]="estadoRaiz"
                    >
                      <span class="nav-link">
                        <mat-icon matSuffix>badge</mat-icon>
                        <span class="text-menu">Roles</span>
                      </span>
                    </a>
                  }

                  <!-- Estados Entidad / Estados de cuenta  -->
                  @if (
                    helper.tienePermiso(
                      'Activos - Cambiar estado de cuenta',
                      'Alarmas - Cambiar estado de cuenta'
                    ) &&
                    helper.tieneModulo(
                      'Alarmas',
                      'Vehículos',
                      'Colectivos',
                      'Activos'
                    )
                  ) {
                    <a
                      mat-list-item
                      routerLinkActive="active"
                      [routerLink]="['administracion/estados-entidad']"
                      [state]="estadoRaiz"
                    >
                      <span class="nav-link">
                        <mat-icon matSuffix>manage_accounts</mat-icon>
                        <span class="text-menu">Estados de Cuenta</span>
                      </span>
                    </a>
                  }

                  <!-- Trackers -->
                  @if (
                    helper.tienePermiso('Administración - Ver trackers') &&
                    helper.tieneModulo('Vehículos', 'Colectivos', 'Activos')
                  ) {
                    <a
                      mat-list-item
                      routerLinkActive="active"
                      [routerLink]="['administracion/trackers']"
                      [state]="estadoRaiz"
                    >
                      <span class="nav-link">
                        <mat-icon matSuffix>gps_fixed</mat-icon>
                        <span class="text-menu">Trackers / GPS</span>
                      </span>
                    </a>
                  }

                  <!-- Dashcams -->
                  @if (
                    helper.tienePermiso('Administración - Ver dashcams') &&
                    helper.tieneModulo('Vehículos', 'Colectivos', 'Activos')
                  ) {
                    <a
                      mat-list-item
                      routerLinkActive="active"
                      [routerLink]="['administracion/dashcams']"
                      [state]="estadoRaiz"
                    >
                      <span class="nav-link">
                        <mat-icon matSuffix>video_camera_front</mat-icon>
                        <span class="text-menu">Dashcams</span>
                      </span>
                    </a>
                  }

                  <!-- SIMs -->
                  @if (helper.tienePermiso('Administración - Ver SIMs')) {
                    <a
                      mat-list-item
                      routerLinkActive="active"
                      [routerLink]="['administracion/sims']"
                      [state]="estadoRaiz"
                    >
                      <span class="nav-link">
                        <mat-icon matSuffix>sim_card</mat-icon>
                        <span class="text-menu">SIMs</span>
                      </span>
                    </a>
                  }

                  <!-- Servicios Contratados -->
                  @if (
                    helper.tienePermiso(
                      'Administración - Ver servicios ofrecidos'
                    ) &&
                    helper.tieneModulo(
                      'Vehículos',
                      'Alarmas',
                      'Activos',
                      'Colectivos'
                    )
                  ) {
                    <a
                      mat-list-item
                      routerLinkActive="active"
                      [routerLink]="['administracion/servicios']"
                      [state]="estadoRaiz"
                    >
                      <span class="nav-link">
                        <mat-icon matSuffix>post_add</mat-icon>
                        <span class="text-menu">Servicios Ofrecidos</span>
                      </span>
                    </a>
                  }
                  <!-- Apikeys -->
                  @if (
                    helper.tienePermiso('Administración - Ver apikeys') &&
                    (clientePropio?.nivel === 0 ||
                      clientePropio?.config?.moduloAdministracion?.verApikeys)
                  ) {
                    <a
                      mat-list-item
                      routerLinkActive="active"
                      [routerLink]="['administracion/apikeys']"
                      [state]="estadoRaiz"
                    >
                      <span class="nav-link">
                        <mat-icon matSuffix>key</mat-icon>
                        <span class="text-menu">Apikeys</span>
                      </span>
                    </a>
                  }

                  <!-- Config Reenvios -->
                  @if (
                    helper.tienePermiso(
                      'Administración - Ver configuraciones de reenvíos'
                    ) &&
                    helper.tieneModulo(
                      'Vehículos',
                      'Alarmas',
                      'Activos',
                      'Colectivos'
                    )
                  ) {
                    <a
                      mat-list-item
                      routerLinkActive="active"
                      [routerLink]="['administracion/config-reenvios']"
                      [state]="estadoRaiz"
                    >
                      <span class="nav-link">
                        <mat-icon matSuffix>forward_to_inbox</mat-icon>
                        <span class="text-menu">Configuración de Reenvíos</span>
                      </span>
                    </a>
                  }

                  <!-- Auditorías -->
                  @if (helper.tienePermiso('Auditorías - Ver auditorías')) {
                    <a
                      mat-list-item
                      routerLinkActive="active"
                      [routerLink]="['administracion/auditorias']"
                      [state]="estadoRaiz"
                    >
                      <span class="nav-link">
                        <mat-icon matSuffix>history</mat-icon>
                        <span class="text-menu">Auditorías</span>
                      </span>
                    </a>
                  }

                  <!-- Temas (sólo admin root) -->
                  @if (helper.esNivel0()) {
                    <a
                      mat-list-item
                      routerLinkActive="active"
                      [routerLink]="['administracion/temas']"
                      [state]="estadoRaiz"
                    >
                      <span class="nav-link">
                        <mat-icon matSuffix>palette</mat-icon>
                        <span class="text-menu">Temas</span>
                      </span>
                    </a>
                  }

                  <!-- Estadísticas de uso (sólo admin root) -->
                  @if (helper.esNivel0()) {
                    <a
                      mat-list-item
                      routerLinkActive="active"
                      [routerLink]="['administracion/estadisticas-uso']"
                      [state]="estadoRaiz"
                    >
                      <span class="nav-link">
                        <mat-icon matSuffix>query_stats</mat-icon>
                        <span class="text-menu">Estadísticas de uso</span>
                      </span>
                    </a>
                  }

                  <!-- Actividad de usuarios (inactividad + periodo de actividad) -->
                  @if (
                    (helper.tienePermiso(
                      'Administración - Ver inactividad usuarios'
                    ) ||
                      helper.tienePermiso(
                        'Administración - Ver periodo actividad usuarios'
                      )) &&
                    helper.tieneModulo(
                      'Vehículos',
                      'Alarmas',
                      'Activos',
                      'Colectivos'
                    )
                  ) {
                    <a
                      mat-list-item
                      routerLinkActive="active"
                      [routerLink]="['administracion/actividad-usuarios']"
                      [state]="estadoRaiz"
                    >
                      <span class="nav-link">
                        <mat-icon matSuffix>insights</mat-icon>
                        <span class="text-menu">Actividad de usuarios</span>
                      </span>
                    </a>
                  }

                  <!-- Exportaciones -->
                  @if (helper.tieneModulo('Alarmas', 'Vehículos')) {
                    <a
                      mat-list-item
                      routerLinkActive="active"
                      [routerLink]="['administracion/exportaciones']"
                      [state]="estadoRaiz"
                    >
                      <span class="nav-link">
                        <mat-icon matSuffix>download</mat-icon>
                        <span class="text-menu">Exportaciones</span>
                      </span>
                    </a>
                  }

                  <!-- Eventos personalizados / categorías / tipos:
                       acción de usuario propia + toggle por cliente -->
                  <!-- Eventos Personalizados -->
                  @if (
                    helper.tienePermiso(
                      'Administración - Ver eventos personalizados'
                    ) &&
                    (clientePropio?.nivel === 0 ||
                      clientePropio?.config?.moduloAdministracion
                        ?.verEventosPersonalizados)
                  ) {
                    <a
                      mat-list-item
                      routerLinkActive="active"
                      [routerLink]="['administracion/config-evento-usuario']"
                      [state]="estadoRaiz"
                      [queryParams]="{ crear: 'Page' }"
                    >
                      <span class="nav-link">
                        <mat-icon matSuffix>rule</mat-icon>
                        <span class="text-menu">Eventos Personalizados</span>
                      </span>
                    </a>
                  }

                  <!-- Categorías Eventos -->
                  @if (
                    helper.tienePermiso(
                      'Administración - Ver categorias eventos'
                    ) &&
                    (clientePropio?.nivel === 0 ||
                      clientePropio?.config?.moduloAdministracion
                        ?.verCategoriasEventos)
                  ) {
                    <a
                      mat-list-item
                      routerLinkActive="active"
                      [routerLink]="['administracion/categoriasEventos']"
                      [state]="estadoRaiz"
                    >
                      <span class="nav-link">
                        <mat-icon matSuffix>category</mat-icon>
                        <span class="text-menu">Categorías Eventos</span>
                      </span>
                    </a>
                  }

                  <!-- Tipos de Eventos -->
                  @if (
                    helper.tienePermiso(
                      'Administración - Ver listado categorias'
                    ) &&
                    (clientePropio?.nivel === 0 ||
                      clientePropio?.config?.moduloAdministracion
                        ?.verTiposEventos)
                  ) {
                    <a
                      mat-list-item
                      routerLinkActive="active"
                      [routerLink]="['administracion/tiposEventos']"
                      [state]="estadoRaiz"
                    >
                      <span class="nav-link">
                        <mat-icon matSuffix>list_alt</mat-icon>
                        <span class="text-menu">Tipos de Eventos</span>
                      </span>
                    </a>
                  }
                </div>
              </mat-expansion-panel>
            }

            <!-- Configuración -->
            <mat-expansion-panel
              id="nav-panel-3"
              [expanded]="expandedPanel === 3"
              (opened)="expandedPanel = 3"
              (closed)="panelClosed(3)"
              (afterExpand)="scrollPanelIntoView('nav-panel-3')"
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>settings</mat-icon>
                  Configuración
                </mat-panel-title>
              </mat-expansion-panel-header>
              <!-- Contenido de configuracion -->
              <div class="expansion-content">
                <!-- Configurar Cliente -->
                @if (
                  helper.tienePermiso('Configuraciones - Configurar cliente')
                ) {
                  <a
                    mat-list-item
                    routerLinkActive="active"
                    [routerLink]="[
                      '/main/administracion/clientes/editar/',
                      this.clientePropio?._id,
                    ]"
                    [state]="estadoRaiz"
                  >
                    <span class="nav-link">
                      <mat-icon matSuffix>settings</mat-icon>
                      <span class="text-menu">Configurar cliente</span>
                    </span>
                  </a>
                }

                <!-- Configurar Usuario -->
                <a
                  mat-list-item
                  routerLinkActive="active"
                  [routerLink]="['/main/administracion/configurar-usuario']"
                  [state]="estadoRaiz"
                >
                  <span class="nav-link">
                    <mat-icon matSuffix>account_circle</mat-icon>
                    <span class="text-menu">Configurar usuario</span>
                  </span>
                </a>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
          <!-- Ayuda -->
          <mat-divider
            class="navigator-divider"
            style="margin: 8px 0"
          ></mat-divider>
          <a
            mat-list-item
            routerLinkActive="active"
            [routerLink]="['ayuda']"
            [state]="estadoRaiz"
            (click)="toggleSidenav()"
          >
            <span class="nav-link">
              <mat-icon matSuffix>help_outline</mat-icon>
              <span class="text-menu">Ayuda</span>
            </span>
          </a>
          <a
            mat-list-item
            routerLinkActive="active"
            [routerLink]="['changelog']"
            [state]="estadoRaiz"
            (click)="toggleSidenav()"
          >
            <span class="nav-link">
              <mat-icon matSuffix>new_releases</mat-icon>
              <span class="text-menu">Changelog</span>
            </span>
          </a>
        </mat-nav-list>
      </div>
      <div class="footer2">
        <mat-divider
          class="navigator-divider"
          style="margin: 8px 0"
        ></mat-divider>
        <app-version></app-version>
      </div>
    </section>
    <div
      class="resize-handle irx-clickeable"
      tabindex="-1"
      aria-hidden="true"
      (mousedown)="startResize($event)"
    ></div>
  </mat-sidenav>

  <!-- Arriba y contenido -->
  <mat-sidenav-content class="navigator-sidenav-content">
    <section class="layout">
      <!-- NAVBAR -->
      <div class="header" [class.navidad-header]="helper.esNavidad()">
        <mat-toolbar class="hideScroll">
          <section class="layout3">
            <!-- Abrir el menú (sólo cuando está cerrado) -->
            @if (!drawer.opened) {
              <div>
                <button
                  irxBotonIcono
                  tono="primario"
                  tooltip="Mostrar menú"
                  (click)="drawer.toggle()"
                >
                  <mat-icon>menu</mat-icon>
                </button>
              </div>
            }
            <!-- Logo de IRIX, siempre visible -->
            <img
              class="shell-logo"
              [src]="
                helper.darkTheme
                  ? 'assets/images/irix_logo_dark.png'
                  : 'assets/images/irix_logo.png'
              "
              alt="IRIX"
            />
            <!-- Decal del tema (leading) -->
            @if (
              (tema$ | async)?.payload?.decalTopbar?.urlAsset;
              as urlTopbar
            ) {
              <img
                [src]="urlTopbar"
                class="topbar-decal"
                [style.height.%]="
                  (tema$ | async)?.payload?.decalTopbar?.tamanoPct ?? 70
                "
                alt=""
              />
            }
            <!-- Spinner -->
            <div class="grow3">
              @if (loading.getLoading()) {
                <mat-progress-spinner
                  diameter="25"
                  mode="indeterminate"
                ></mat-progress-spinner>
              }
            </div>
            <!-- Botones de la derecha -->
            <div class="row-center">
              <!-- Banner -->
              @if (helper.darkTheme) {
                @if (temas.bannerDarkMode) {
                  <img
                    src="{{ temas.bannerDarkMode }}"
                    alt="banner"
                    class="banner"
                  />
                } @else {
                  @if (temas.banner) {
                    <img src="{{ temas.banner }}" alt="banner" class="banner" />
                  }
                }
              } @else {
                @if (temas.banner) {
                  <img src="{{ temas.banner }}" alt="banner" class="banner" />
                } @else {
                  @if (temas.bannerDarkMode) {
                    <img
                      src="{{ temas.bannerDarkMode }}"
                      alt="banner"
                      class="banner"
                    />
                  }
                }
              }
              <!-- Tratamiento minimizado -->
              @if (tratamientoMinimizado.isMinimizado) {
                <button
                  irxBotonIcono
                  class="tratamiento-minimizado-btn"
                  [tooltip]="
                    (tratamientoMinimizado.info?.titulo || 'Tratamiento') +
                    (tratamientoMinimizado.info?.subtitulo
                      ? ' · ' + tratamientoMinimizado.info.subtitulo
                      : '')
                  "
                  (click)="tratamientoMinimizado.restaurar()"
                >
                  <mat-icon>assignment</mat-icon>
                  <span class="tratamiento-minimizado-badge"></span>
                </button>
              }
              <!-- Notificaciones -->
              <app-descargas></app-descargas>
              <!-- Notificaciones -->
              <app-notificaciones></app-notificaciones>
              <!-- Config -->
              <button
                irxBotonIcono
                tooltip="Personalizar"
                [disabled]="!this.clientePropio?._id"
                (click)="openAppSettings()"
              >
                <mat-icon>settings</mat-icon>
              </button>
            </div>
          </section>
        </mat-toolbar>
      </div>
      <!-- MAIN -->
      <div class="main" id="router">
        <app-barra-migas></app-barra-migas>
        <router-outlet></router-outlet>
      </div>
    </section>
  </mat-sidenav-content>
</mat-sidenav-container>
